import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useState } from "react";
import feedbackService from "../services/feedbackService";
import { FeedbackModal } from "./common/ui/FeedbackModal";

const ThumsUpDown = ({ dialogId }) => {
  const [likeDislike, setLikeDislike] = useState(null);
  const [feedbackModal, setFeedbackModal] = useState(false);

  const sendFeedback = async (dialogFeedback) => {
    if (!likeDislike) return;

    const feedback_body = {
      reaction_emoji: likeDislike,
      dialog_id: dialogId,
      dialog_feedback:dialogFeedback
    };
    console.log(feedback_body);
    

    try {
      const data = await feedbackService.feedback(feedback_body);
      console.log("Feedback response:", data);
    } catch (error) {
      console.error("Error sending feedback:", error);
    }
    setFeedbackModal(false)
  };
  

  const handleLike = () => {
    if (!likeDislike) {
      setLikeDislike("like");
      setFeedbackModal(true);
    }
  };

  const handleDisLike = () => {
    if (!likeDislike) {
      setLikeDislike("dislike");
      setFeedbackModal(true);
    }
  };

  const handleClose = () => {
    setFeedbackModal(false);
  };

  return (
    <div className="flex gap-2">
      <button
        className={`p-1 border rounded h-[1.87rem] ${
          likeDislike && likeDislike !== "like"
            ? "cursor-not-allowed opacity-50"
            : ""
            
        } hover:bg-gray-100`}
        title="Like"
        onClick={handleLike}
        disabled={likeDislike !== null}
      >
        <ThumbsUp size={19} className={likeDislike === "like" ? "text-blue-600 fill-blue-500" : "text-gray-700"} />
      </button>
      <button
        className={`p-1 border rounded h-[1.87rem]  ${
          likeDislike && likeDislike !== "dislike"
            ? "cursor-not-allowed opacity-50"
            : ""
        } hover:bg-gray-100`}
        title="Dislike"
        onClick={handleDisLike}
        disabled={likeDislike !== null}
      >
        <ThumbsDown size={19} className={likeDislike === "dislike" ? "text-red-600 fill-red-500" : "text-gray-700"} />
      </button>
      {feedbackModal && (
        <FeedbackModal
          isOpen={feedbackModal}
          onConfirm={sendFeedback}
          onCancel={handleClose}
        />
      )}
    </div>
  );
};

export default ThumsUpDown;
